<template>
  <v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

    <v-card class="form-container" flat style="margin-top:-10px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12 sm12 md6 style="padding-right:5px">
                <v-text-field v-model="form.vendorName" label="Vendor Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
                <v-text-field v-model="form.contactName" label="Contact Person Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field v-model="form.contactNumber" label="Contact Number *" :rules="[rules.mobileno]" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field v-model="form.gstNumber" label="GST Number"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3>
                <v-text-field v-model="form.panNumber" label="Pan Number"></v-text-field>
            </v-flex>

            <!-- BILLING  -->
          <v-flex xs12 md6 sm6 style="padding-right: 5px">
            <v-text-field v-model="form.billingCity" label="Billing city"></v-text-field>
            <v-text-field
              v-model="form.billingCountry"
              label="Billing country"
            ></v-text-field>
            <v-text-field
              v-model="form.billingZipCode"
              label="Billing zip code"
            ></v-text-field>
            <v-text-field
              v-model="form.billingStreet"
              label="Billing street"
            ></v-text-field>
            <v-autocomplete
              v-model="selectedBillingState"
              :items="states"
              color="primary"
              label="Select billing state *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            <v-textarea
              v-model="form.billingAddress"
              label="Billing address"
            ></v-textarea>
          </v-flex>

          <!-- SHIPPING -->
          <v-flex xs12 md6 sm6 style="padding-left: 5px">
            <v-text-field
              v-model="form.shippingCity"
              label="Shipping city"
            ></v-text-field>
            <v-text-field
              v-model="form.shippingCountry"
              label="Shipping country"
            ></v-text-field>
            <v-text-field
              v-model="form.shippingZipCode"
              label="Shipping zip code"
            ></v-text-field>
            <v-text-field
              v-model="form.shippingStreet"
              label="Shipping Street"
            ></v-text-field>
            <v-autocomplete
              v-model="selectedShippingState"
              :items="states"
              color="primary"
              label="Select shipping state *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            <v-textarea
              v-model="form.shippingAddress"
              label="Shipping address"
            ></v-textarea>
          </v-flex>

          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Counselling",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Vendor",
          disabled: false,
          to: "/vendor"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],
      form: {
          vendorName: '',
          gstNumber: '',
          panNumber: '',
          contactName: '',
          contactNumber: '',

          billingAddress: '',
          billingCity: '',
          billingCountry: '',
          billingStreet: '',
          billingZipCode: 0,

          shippingAddress: '',
          shippingCity: '',
          shippingCountry: '',
          shippingStreet: '',
          shippingZipCode: 0
      },

      states: null,
      selectedBillingState: 1,
      selectedShippingState: 1,
    };
  },

  mounted() {
      this.axios
        .get(config.API + `States`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
          this.$Progress.finish();
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Vendors`,
            {
              billingAddress: this.form.billingAddress,
              billingCity: this.form.billingCity,
              billingCountry: this.form.billingCountry,
              billingStateCode: JSON.parse(this.selectedBillingState),
              billingStreet: this.form.billingStreet,
              billingZipCode: JSON.parse(this.form.billingZipCode),
              vendorName: this.form.vendorName,
              contactName: this.form.contactName,
              contactNumber: this.form.contactNumber,
              email: this.form.email,
              gstNumber: this.form.gstNumber,
              panNumber: this.form.panNumber,
              shippingAddress: this.form.shippingAddress,
              shippingCity: this.form.shippingCity,
              shippingCountry: this.form.shippingCountry,
              shippingStateCode: JSON.parse(this.selectedShippingState),
              shippingStreet: this.form.shippingStreet,
              shippingZipCode: JSON.parse(this.form.shippingZipCode)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            //this.$router.push(`counsellingImage/${code}`);
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
